
    import '/mnt/src/components/Card/index.md?watch=parent';
    export const demoIndex = {
  ids: ["card-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Card/index.md?type=demo')
};